import { Mutation } from 'vuex';
import { IModuleState } from './types';
import { flattenTree } from '@/utils/object';
import * as util from '@/store/materials/nav/util';

// 正在展示的导航树
export const setCurrentNav: Mutation<IModuleState> = (state, payload) => {
  const trees = util.navTreeBuild(payload.raw, []);
  state.currentNav.data = payload.raw ? trees : state.currentNav.data;
  state.currentNav.list = flattenTree(trees);
  state.currentNav.loading = !!payload.loading;
};

// 已发布的导航树
export const setPublishedNav: Mutation<IModuleState> = (state, payload) => {
  state.publishedTree.data = payload.data;
  state.publishedTree.loading = !!payload.loading;
};

// 带版本的导航树
export const setVersionDetail: Mutation<IModuleState> = (state, payload) => {
  state.versionTree.data = payload.data;
  state.versionTree.loading = !!payload.loading;
};

// 分类过滤项层级树
export const setCategoryTree: Mutation<IModuleState> = (state, payload) => {
  state.categoryTree.data = payload.data;
  state.categoryTree.loading = !!payload.loading;
};

// 标签过滤项列表
export const setLabelList: Mutation<IModuleState> = (state, payload) => {
  state.labelList.data = payload.data;
  state.labelList.loading = !!payload.loading;
};

// 历史导航列表(历史版本列表)
export const setVersionList: Mutation<IModuleState> = (state, payload) => {
  state.versionList.data = payload.data;
  state.versionList.loading = !!payload.loading;
};

// 预览搜索列表
export const setPreviewList: Mutation<IModuleState> = (state, payload) => {
  state.previewList.data = payload.data;
  state.previewList.pageNum = payload.pageNum;
  state.previewList.pageSize = payload.pageSize;
  state.previewList.total = payload.total;
  state.previewList.loading = !!payload.loading;
};

// 相关弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
  state.dialog.type = payload.type || '';
  state.dialog.data = payload.data || null;
};

// 节点排序
export const setNodeSort: Mutation<IModuleState> = (state, payload) => {
  state.nodeSort.id = payload.id || null;
  state.nodeSort.loading = !!payload.loading;
};

// 展开或收起历史导航列表
export const setVersionExpand: Mutation<IModuleState> = (state, payload) => {
  state.versionExpand = !!payload;  // true 表示展开
};

// 节点保存中
export const setNodeSaving: Mutation<IModuleState> = (state, payload) => {
  state.nodeSaving = !!payload;
};

// 配置保存中
export const setConfigSaving: Mutation<IModuleState> = (state, payload) => {
  state.configSaving = !!payload;
};
